import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		marginBottom: THEME.spacing.lg,
		width: '100%',
	},
	sectionHeader: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		gap: THEME.spacing.md,
	},
	sectionTitle: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.semibold,
		margin: 0,
	},
	accountCard: {
		alignItems: 'center',
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		justifyContent: 'space-between',
		padding: THEME.spacing.md,
	},
	accountDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	accountName: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	accountType: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	locationList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		listStyle: 'none',
		margin: 0,
		padding: 0,
	},
	locationCard: {
		alignItems: 'center',
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		gap: THEME.spacing.md,
		justifyContent: 'space-between',
		padding: THEME.spacing.md,
	},
	locationTitle: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	rating: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	reviewCount: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	syncDisabled: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		fontStyle: 'italic',
	},
	listHint: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		margin: `0 0 ${THEME.spacing.sm}px`,
	},
	locationSummary: {
		alignItems: 'baseline',
		display: 'flex',
		flexWrap: 'wrap',
		flexGrow: 1,
		gap: THEME.spacing.sm,
		minWidth: 0,
	},
	locationAction: {
		alignItems: 'center',
		display: 'flex',
		flexShrink: 0,
	},
	saveBar: {
		alignItems: 'center',
		background: THEME.colors.background.main,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'flex-end',
		marginTop: THEME.spacing.sm,
		padding: THEME.spacing.sm,
		width: '100%',
	},
	saveBarText: {
		color: THEME.colors.text.light,
		flexGrow: 1,
		fontSize: THEME.typography.fontSizes.sm,
	},
	warning: {
		alignItems: 'flex-start',
		background: THEME.colors.warning.light,
		border: `1px solid ${THEME.colors.warning.main}`,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.text.dark,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		fontSize: THEME.typography.fontSizes.sm,
		padding: THEME.spacing.md,
	},
	warningTitle: {
		fontWeight: THEME.typography.fontWeights.semibold,
	},
});
